<template>
<div class="content" style="background-color: white">
  <header class="bar bar-nav">
    <router-link class="button button-link button-nav pull-left" :to="{ name: 'me'}">
      <span class="icon icon-left"></span>
      返回
    </router-link>
    <h1 class='title'>消息管理 </h1>
  </header>
<div class="card" style="margin-top: 3rem">
    <div class="card-content">
      <div class="list-block media-list">
        <ul v-for="(merch,index) in merchantMessages" style="border-bottom:1px solid gainsboro;padding-top: 5px">
          <a @click="goto(merch)">
          <li class="item-content" heigh="20" >
            <div class="item-media" v-bind:style="{'background-image': 'url('+ url + ') ', 'padding': '5px', 'background-size': '100% 100%', 'width': '2rem', 'height': '2rem', 'position': 'relative'}">
              <!--<img :src="'static/img/customerService.jpeg'"  width="35">-->
              <div class="tips" v-if="merch.unreadMessagesAmount > 0">{{merch.unreadMessagesAmount}}</div>
            </div>
            <div class="item-inner" style="padding: 5px">
              <div class="item-title-row" style="font-size: small">
                <div class="item-title" style="color: black;">
                   {{merch.merchantName}}</div>
                <div style="font-size: xx-small;color: gray;float:right;margin-top:3px" v-if="merch.lastestMessage.createDT.substring(0,10) === date1">{{merch.lastestMessage.createDT.substring(11)}}</div>
                <div style="font-size: xx-small;color: gray;float:right;margin-top:3px" v-else>{{merch.lastestMessage.createDT.substring(0,10)}}</div>
              </div>
              <div class="item-subtitle" style="color: gray;font-size: small" v-if="merch.lastestMessage.message.length > 20">{{merch.lastestMessage.message.substring(0,15)+'.....'}}</div>
              <div class="item-subtitle" style="color: gray;font-size: small" v-else>{{merch.lastestMessage.message}}</div>
            </div>
          </li>
          </a>
        </ul>
      </div>
    </div>
  </div>
</div>
</div>
</template>
<script>
  import { mapMutations, mapGetters } from 'vuex'
  export default {
    data () {
      return {
        merchantMessages: [],
        responseMessages: [],
        date1: '',
        url: '/emktResources/resocurces/img/customerService.jpeg'
      }
    },
    methods: {
      ...mapMutations([
        'INIT_MESSAGE'
      ]),
      fetchData () {
//        var responsemerchantMessages = this.curMessageSession.merchantMessages
//        for (var i in responsemerchantMessages) {
//          var merch = {}
//          merch.messages = responsemerchantMessages[i]
//          merch.merchantNo = responsemerchantMessages[i][0].merchantNo
//          for (var j = responsemerchantMessages[i].length - 1; j >= 0; j--) {
//            if (responsemerchantMessages[i][j].messageType === 2) {
//              merch.responseMessage = responsemerchantMessages[i][j].message
//              break
//            }
//          }
//        this.INIT_MESSAGE('INIT_MESSAGE')
        this.merchantMessages = this.curMessageSession.merchantMessages
        var date = new Date()
        var month = date.getMonth() + 1
        var strDate = date.getDate()
        if (month >= 1 && month <= 9) {
          month = '0' + month
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = '0' + strDate
        }
        this.date1 = date.getFullYear() + '-' + month + '-' + strDate
      },
      goto (merch) {
        this.$router.push({name: 'myMessage', query: { Messages: merch }})
      }
    },
    computed: {
      ...mapGetters([
        'curMessageSession'
      ])
    },
    mounted () {
      this.fetchData()
    },
    created () {
      this.fetchData()
    },
    watch: {
    }
  }
</script>

<style>
  .tips {
    position:absolute;
    right:-10px;
    top:-10px;
    border-radius:50%;
    background-color: red;
    width: 15px;
    height: 15px;
    font-size: x-small;
    color: white;
    text-align: center
  }
  </style>



// WEBPACK FOOTER //
// MessageManagement.vue?9b3f9806